import { usePictureSets } from "@/react/Webshop/hooks/usePictureSets";
import { isImageResource } from "@/types/template";
const useRetouch = () => {
    const { getPictureByUuid } = usePictureSets();
    const getRetouchPicturesByOrderLines = (orderLines) => {
        const seen = new Set();
        orderLines.forEach((line) => {
            console.log("Checking order line", line);
            let pictures = [];
            if ("template" in line) {
                pictures = getPictureUuidsForTemplateOrderLine(line);
            }
            else if ("package" in line) {
                pictures = getPictureUuidsForPackageOrderLine(line);
            }
            else if ("digitalFiles" in line) {
                pictures = getPictureUuidsForDigitalFileOrderLine(line);
            }
            pictures.forEach((uuid) => seen.add(uuid));
        });
        const pictureUuids = Array.from(seen);
        const pictures = [];
        pictureUuids.forEach((uuid) => {
            const picture = getPictureByUuid(uuid);
            if (picture && picture.pictureType === "IP") {
                pictures.push(picture);
            }
        });
        return pictures;
    };
    return { getRetouchPicturesByOrderLines };
};
const getPictureUuidsByResources = (userResources) => {
    var _a;
    const pictures = {};
    for (const resourceId in userResources) {
        const resource = userResources[resourceId];
        if (!isImageResource(resource)) {
            continue;
        }
        console.log("User resource by id", resourceId, userResources);
        const imageUuid = (_a = resource.image) === null || _a === void 0 ? void 0 : _a.uuid;
        console.log("Unique", imageUuid);
        if (imageUuid) {
            pictures[imageUuid] = true;
        }
    }
    return Object.keys(pictures);
};
const getPictureUuidsForTemplateOrderLine = (orderLine) => {
    const userResources = orderLine.template.data.userResources;
    return getPictureUuidsByResources(userResources);
};
const getPictureUuidsForDigitalFileOrderLine = (orderLine) => {
    return orderLine.digitalFiles.map((df) => df.uuid);
};
const getPictureUuidsForPackageOrderLine = (orderLine) => {
    const pictures = orderLine.package.packageItems.reduce((acc, item) => {
        console.log("Package looping item", item);
        if ("template" in item) {
            const uuids = getPictureUuidsByResources(item.templateData.userResources);
            console.log("Package looping found uuids", uuids);
            return acc.concat(uuids);
        }
        if ("files" in item) {
            return acc.concat(item.files.map((file) => file.uuid));
        }
        return acc;
    }, []);
    // dedup
    return Array.from(new Set(pictures));
};
export default useRetouch;
